import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateCompute'
})
export class DateComputePipe implements PipeTransform {

  transform(value: Date, operation: moment.DurationInputArg1, unit: moment.DurationInputArg2, amount: number): Date {
    switch (operation) {
    case 'add':
      return moment(value).add(amount, unit).toDate();
    case 'subtract':
      return moment(value).subtract(amount, unit).toDate();
    default:
      throw new Error('Invalid operation');
    }
  }

}
